import React, { Component } from 'react';
import { connect } from 'react-redux';

import { recordLap } from '../../actions';

import Laps from "./Laps";


import '../../stylesheets/stopwatch.css';

class Stopwatch extends Component{
    constructor(props){
        super(props);
        this.state={
            m:0,
            s:0,
            ms:0,
            action:null,
            laps:[]
        }
        
    }


    
    leadingZero(num){
        num = (num<10) ? '0'+num : num
        return num;
    }

    start(){
        this.setState({action:'start'});
        this.interval = setInterval(()=>{
            let {m,s,ms} = this.state;
            this.setState({ms:ms+1});
            if(this.state.ms===300){
                this.setState({ms:0,s:s+1});
                if(this.state.s===60){
                    this.setState({s:0,m:m+1});
                }
            }
        });
        
    }
    pause(){
        this.setState({action:'pause'});
        clearInterval(this.interval);
    }
    flag(){
        let {m,s,ms,laps} = this.state;
        let lap = m+':'+s+'.'+ms;
        laps.push(lap);
        this.setState({laps});
        this.props.recordLap(lap);
        this.clear();
    }
    clear(){
        this.setState({
            m:0,
            s:0,
            ms:0,
            action:null});
        clearInterval(this.interval);
        this.interval=null;
    }


    timeBox(){
        let {m,s,ms} = this.state;
        //console.log(this.props.laps);
        return(
           
            <div className='row time-box-row'>
            
            <div className='time-box'>{this.leadingZero(m)}:{this.leadingZero(s)}.<small>{this.leadingZero(ms)}</small></div>
           
            
            </div>
            
           
        )
    }
    
    
    buttonBox(){
        let myClass = `fa fa-${(this.state.action==='start')?'pause':'play'}`;
        let action  = (this.state.action==='start')?()=>this.pause():()=>this.start();
        
        return(
            <div>
                <button className='btn time-btn' onClick={action}><i className={myClass}></i></button>
                <button className='btn time-btn' 
                onClick={()=>this.flag()}
                disabled={this.state.action===null?'disabled':null}>
                <i className='fas fa-flag-checkered'></i></button>
                <button className='btn time-btn' 
                onClick={()=>this.clear()}
                disabled={this.state.action===null?'disabled':null}>
                <i className='fas fa-backspace'></i></button>
                
            </div>
        )
    }

    render(){
        return(
            <div className='App container'>
                <div className='App-title'>Stopwatch <i className='fas fa-stopwatch'></i></div>
                <div>
                {/* <TimeBox action={this.state.action}/> */}
                {this.timeBox()}
                {this.buttonBox()}
                <Laps laps={this.props.laps}/>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state){
    let {laps} = state;
    return{laps}
}


export default connect(mapStateToProps,{recordLap})(Stopwatch);


// WEBPACK FOOTER //
// ./src/components/stopwatch/Stopwatch.jsx